import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { CoreEngineObject, CoreEngineService } from '../_services/core-engine.service';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Engine } from '../_models/Engine';
import { UserService } from '../_services/user.service';
import { getUrl } from '../_shared/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';

@Component({
  selector: 'app-core-engine',
  templateUrl: './core-engine.component.html',
  styleUrls: ['./core-engine.component.css']
})

export class CoreEngineManagementComponent implements OnInit  {

  displayObjects: CoreEngineObject[];
  public downloadStates = {};
  loading = false;

  constructor(
    private coreEngineService: CoreEngineService,
    private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private httpClient: HttpClient,
    private jwtTokenService: JWTTokenService,
    private spinner: NgxSpinnerService
  ) {

  }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.coreEngineService.getCoreEngineObjects().subscribe(objects => {
      this.displayObjects = objects;
      this.loading = false;
      this.spinner.hide();
    },
    err => {
      this.loading = false;
      this.spinner.hide();
    });
  }

  edit(objectId: number) {
    this.router.navigate([`/portal/${this.GetRouteName()}/create`, objectId]);
  }

  delete(object: any) {
      this.loading = true;
      this.spinner.show();
      this.coreEngineService.delete(object.coreEngineObjectId).subscribe(() => {
        this.displayObjects.splice(this.displayObjects.indexOf(object), 1);
        this.loading = false;
        this.spinner.hide();
    });
  }

  public download(objectId: number, rowIndex: number) {
    this.loading = true;
    this.spinner.show();
    this.downloadStates[rowIndex + '-download'] = 1;
    this.downloadStates[rowIndex + '-downloadPercent'] = 0;
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Authorization': 'Bearer ' + this.jwtTokenService.getToken('portal')
    });
    this.httpClient.get(getUrl(`coreengine/objects/download/${objectId}`), {headers: headers}).subscribe(
      (signedUrls: any) => {
        const headUrl = signedUrls.headUrl;
        const downloadUrl = signedUrls.getUrl;
        const fileName = signedUrls.fileName;
        const options = { responseType: 'blob' as 'blob' };

        this.httpClient.head(headUrl, options).subscribe(
          (response: any) => {

            const req = new HttpRequest('GET', downloadUrl, {
              reportProgress: true,
              observe: 'events',
              responseType: 'blob'
            });

            this.httpClient.request<any>(req).subscribe(event => {
              // Access event stream to report progress
              if (event.type === HttpEventType.DownloadProgress) {
                // Calculate percentage done from the 'Content-Size'
                const percentDone = Math.round(100 * event.loaded / event.total);
                this.downloadStates[rowIndex + '-downloadPercent'] = percentDone;
              } else if (event instanceof HttpResponse) {
                const url = window.URL.createObjectURL(event.body);
                const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.downloadStates[rowIndex + '-download'] = 3;
                this.loading = false;
                this.spinner.hide();
              }
            });
          },
          err => {
            this.dialogService.alert('Download Error', 'There appears to be an error with your file, please contact support@connectwithcue.com, sorry about that!', this.viewRef);
            this.downloadStates[rowIndex + '-download'] = 4;
            this.loading = false;
            this.spinner.hide();
          });
      },
      () => {
        this.dialogService.alert('Download Error', 'There appears to be an error with your file, please contact support@connectwithcue.com, sorry about that!', this.viewRef);
        this.downloadStates[rowIndex + '-download'] = 4;
        this.loading = false;
        this.spinner.hide();
      }
    );
  }

  protected GetRouteName(): string {
    return 'audio-qr';
  }

  public createNew() {
    this.router.navigate([`/portal/${this.GetRouteName()}/create`]);
  }
}
